import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import distanceCoursesRoutes from 'modules/trainingLibrary/DistanceCourses/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const DistanceCourseDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsDistanceCourseDetails" */ 'modules/activityDetails/DistanceCourseDetails/pages/DistanceCourseDetails'
    )
)

const DistanceCourseDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:distanceCourseId`} component={DistanceCourseDetails} />
      <Redirect path='*' to={distanceCoursesRoutes.root} />
    </Switch>
  </Suspense>
)

export default DistanceCourseDetailsRouting
